import type { PaginationArguments, PaginationPageInfo } from "#gen/common/v1/pagination_pb.js";
import { ComplianceService, type Job } from "#gen/compliance/v1/compliance_pb.js";
import type { MappedValue } from "#gen/workflows/v1/workflows_pb.js";
import { createClient, type ClientOptions } from "#lib/api/api.js";
import { handleError } from "#lib/api/error.js";
import { PUBLIC_URLS } from "#lib/url.js";
import type { CallOptions, Client } from "@connectrpc/connect";

export interface ComplianceJobList {
	jobs: Job[];
	pageInfo?: PaginationPageInfo;
}

export class ComplianceClient {
	private client: Client<typeof ComplianceService>;

	constructor(options?: () => ClientOptions) {
		this.client = createClient(PUBLIC_URLS.compliance || "/", ComplianceService, options);
	}

	async listJobs(orgId: string, pagination?: PaginationArguments, options?: CallOptions): Promise<ComplianceJobList> {
		try {
			const res = await this.client.listJobs(
				{
					orgId,
					pagination,
				},
				options,
			);
			return res;
		} catch (e) {
			throw handleError(e);
		}
	}

	async bulkPurgeData(orgId: string, fileUrl: string, fileName: string, size: number, mapping: { [key: string]: MappedValue }, hasHeader: boolean, header: string[], options?: CallOptions): Promise<void> {
		try {
			await this.client.bulkPurgeData(
				{
					orgId,
					fileUrl,
					fileName,
					size,
					mapping,
					hasHeader,
					header: hasHeader ? header : undefined,
				},
				options,
			);
		} catch (e) {
			throw handleError(e);
		}
	}
}
